module.exports = __webpack_public_path__ + "img/森川正明.2cf25c7f.png";